import type { ListStonesParams } from '@nucleus-commerce/api-client/platform';

export const diamondKeys = {
  all: ['diamonds'] as const,
  suppliers: () => [...diamondKeys.all, 'suppliers'] as const,
  stones: () => [...diamondKeys.all, 'stones'] as const,
  stoneList: (params: ListStonesParams) => [...diamondKeys.stones(), params] as const,
};
